module.exports = __webpack_public_path__ + "assets/images/print-icon.svg";